import { useEffect, useState } from "react";
import { Navigate, useNavigate, useSearchParams } from "react-router-dom";
import { PawPrint } from "lucide-react";
import { useAdminAuth } from "./AdminAuthContext";

function safeReturnTo(value) {
  return value && value.startsWith("/admin") && !value.startsWith("//") ? value : "/admin";
}

export default function AdminLogin() {
  const { status, login } = useAdminAuth();
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const returnTo = safeReturnTo(params.get("returnTo"));

  useEffect(() => {
    if (status === "authenticated") navigate(returnTo, { replace: true });
  }, [status, navigate, returnTo]);

  if (status === "checking") {
    return <main style={{ minHeight: "100vh", display: "grid", placeItems: "center", fontFamily: "'Nunito', sans-serif", color: "#6A4FC0" }}>Checking administrator session…</main>;
  }
  if (status === "authenticated") return <Navigate to={returnTo} replace />;

  const submit = async (event) => {
    event.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(password);
      navigate(returnTo, { replace: true });
    } catch (err) {
      setError(err.message || "Admin login failed.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <main style={{ minHeight: "100vh", display: "grid", placeItems: "center", padding: 24, background: "#F7F6FB", fontFamily: "'Nunito', sans-serif", color: "#2A2540" }}>
      <form onSubmit={submit} style={{ width: "100%", maxWidth: 390, background: "#fff", border: "1px solid #ECEAF3", borderRadius: 18, padding: 30, boxShadow: "0 18px 45px rgba(67, 50, 115, 0.10)" }} data-testid="admin-login-form">
        <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 8 }}>
          <PawPrint size={28} color="#7A5CD0" fill="#7A5CD0" />
          <h1 style={{ margin: 0, fontSize: 24 }}>Administrator Login</h1>
        </div>
        <p style={{ margin: "0 0 22px", color: "#7A728D", fontSize: 14 }}>Enter the Paw-Some Reports administrator password.</p>
        <label htmlFor="admin-password" style={{ display: "block", fontWeight: 800, fontSize: 13, marginBottom: 7 }}>Password</label>
        <input id="admin-password" data-testid="admin-password" type="password" autoComplete="current-password" required autoFocus value={password} onChange={(event) => setPassword(event.target.value)} style={{ boxSizing: "border-box", width: "100%", border: "1px solid #DCD7EA", borderRadius: 10, padding: "11px 12px", font: "inherit", marginBottom: 12 }} />
        {error ? <div role="alert" data-testid="admin-login-error" style={{ background: "#FEE2E2", color: "#991B1B", borderRadius: 9, padding: 10, fontSize: 13, marginBottom: 12 }}>{error}</div> : null}
        <button type="submit" disabled={busy} data-testid="admin-login-submit" style={{ width: "100%", border: 0, borderRadius: 10, padding: "11px 14px", background: "#6A4FC0", color: "#fff", fontWeight: 800, fontSize: 14, cursor: busy ? "wait" : "pointer" }}>{busy ? "Signing in…" : "Sign In"}</button>
      </form>
    </main>
  );
}
